var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBattery = function SvgBattery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 21,
    viewBox: "0 0 26 21",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.47692
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000033"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.9333 4.19672h-21.86663c-.58911 0-1.06667.47708-1.06667 1.06558v13.8525c0 .5885.47756 1.0655 1.06667 1.0655h21.86663c.5891 0 1.0667-.477 1.0667-1.0655v-13.8525c0-.5885-.4776-1.06558-1.0667-1.06558z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.26686 1.00001h2.66667c.2829 0 .55421.11226.75425.3121.20003.19983.31242.47086.31242.75347v2.13115h-4.8v-2.13115c0-.28261.11238-.55364.31241-.75347.20004-.19984.47135-.3121.75425-.3121z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7998 4.19672h-4.8v-2.13114c0-.28261.1124-.55364.3124-.75348.2001-.19983.4714-.3121.7543-.3121h2.6666c.2829 0 .5542.11227.7543.3121.2.19984.3124.47087.3124.75348z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "battery-icon-electric",
    d: "m13.0001 7.39345-2.4 4.79505h4l-2.4 4.7951",
    stroke: "#000033"
  }))));
};
export default SvgBattery;